export default "__VITE_ASSET__Bj1Vlosb__"